{
    "Profile_Vehicles_Vehicle.vehicleDetails": "Vehicle Details",
    "Profile_Vehicles_Vehicle.number": "Number",
    "Profile_Vehicles_Vehicle.year": "Year",
    "Profile_Vehicles_Vehicle.make": "Make",
    "Profile_Vehicles_Vehicle.model": "Model",
    "Profile_Vehicles_Vehicle.vicc": "VICC",
    "Profile_Vehicles_Vehicle.vin": "VIN",
    "Profile_Vehicles_Vehicle.additionalAlarm": "Additional Alarm",
    "Profile_Vehicles_Vehicle.engravings": "Engravings",
    "Profile_Vehicles_Vehicle.tracking": "Tracking",
    "Profile_Vehicles_Vehicle.garageType": "Garage Type",
    "Profile_Vehicles_Vehicle.garagedAtInsuredAddress": "Garaged at Insured Address",
    "Profile_Vehicles_Vehicle.garagingAddress": "Garaging Address",
    "Profile_Vehicles_Vehicle.ownershipDetails": "Ownership Details",
    "Profile_Vehicles_Vehicle.owned": "Owned",
    "Profile_Vehicles_Vehicle.lessor": "Lessor",
    "Profile_Vehicles_Vehicle.financed": "Financed",
    "Profile_Vehicles_Vehicle.financerLender": "Financer Lender",
    "Profile_Vehicles_Vehicle.financeRate": "Finance Rate",
    "Profile_Vehicles_Vehicle.purchasedUsed": "Purchased Used",
    "Profile_Vehicles_Vehicle.purchaseDate": "Purchase Date",
    "Profile_Vehicles_Vehicle.purchaseValue": "Purchase Value",
    "Profile_Vehicles_Vehicle.currentValue": "Current Value",
    "Profile_Vehicles_Vehicle.newValue": "New Value",
    "Profile_Vehicles_Vehicle.usageDetails": "Usage Details",
    "Profile_Vehicles_Vehicle.leisureActivity": "Leisure Activity",
    "Profile_Vehicles_Vehicle.dailyCommute": "Daily Commute",
    "Profile_Vehicles_Vehicle.businessActivity": "Business Activity",
    "Profile_Vehicles_Vehicle.rideshare": "Rideshare",
    "Profile_Vehicles_Vehicle.winterTires": "Winter Tires",
    "Profile_Vehicles_Vehicle.storedForWinter": "Stored for winter",
    "Profile_Vehicles_Vehicle.storageStart": "Storage Start",
    "Profile_Vehicles_Vehicle.storageEnd": "Storage End",
    "Profile_Vehicles_Vehicle.vehicleUsage": "Vehicle Usage",
    "Profile_Vehicles_Vehicle.newUsage": "New Usage"
}
